module.exports = __webpack_public_path__ + "static/media/icon-globe.50d70b6d.svg";